module.exports = __webpack_public_path__ + "img/stamp3.92c211b2.jpg";